module.exports = __webpack_public_path__ + "static/img/brain_games_title.2bb6671.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/game/brain_games_title.png
// module id = Zv/p
// module chunks = 1